import { parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import PlannerCalendar from '../models/PlannerCalendar';
import { parsePlannerCalendarEvents } from './plannerCalendarEventConverters';

const SCHEMA = {
  month: 'month',
  year: 'year',
  events: (item: any) => parsePlannerCalendarEvents(item.calendar),
  closeDayFrom: (data: any) => parseMoment(data.dailyPlanningClosureFrom, DateTimeFormat.LEGACY),
};

export function parsePlannerCalendar(data: any): PlannerCalendar | null {
  return parseEntity(data, SCHEMA, PlannerCalendar);
}